import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";
import { Flag } from "lucide-react";
import type { FC } from "react";
import { edgeAwareTransform } from "web_myplann/Goals/Helpers/edgeAwareTransform";
import type { WhatIf } from "web_myplann/Goals/Hooks/useWhatIf";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	plan: WhatIf;
};

export const WhatIfEarlierViz: FC<Props> = ({ plan }) => {
	const theme = useTheme();
	const { t } = useResource();
	const accent = theme.palette.success.main;
	const markerTransform = edgeAwareTransform(plan.newPct);

	return (
		<Stack pt={1.2} gap={1.2}>
			<Box position="relative" height={44}>
				<Box
					position="absolute"
					left={0}
					right={0}
					top={8}
					height="1px"
					bgcolor={theme.palette.grey[200]}
				/>
				<Typography
					variant="hint"
					tabular
					sx={{
						position: "absolute",
						left: 0,
						top: 18,
						opacity: plan.newPct < 20 ? 0 : 1,
						transition: "opacity 150ms ease-out",
					}}
				>
					{t(Resources.Goals.Detail.WhatIf.Earlier.today)}
				</Typography>
				<Typography
					variant="hint"
					tabular
					sx={{
						position: "absolute",
						right: 0,
						top: 18,
						opacity: plan.newPct > 80 ? 0 : 1,
						transition: "opacity 150ms ease-out",
					}}
				>
					{plan.dueYear}
				</Typography>
				<Stack
					alignItems="center"
					sx={{
						position: "absolute",
						left: `${plan.newPct}%`,
						top: -4,
						transform: "translateX(-50%)",
					}}
				>
					<Flag size={16} color={accent} fill={accent} />
					<Box width="1px" height={8} bgcolor={alpha(accent, 0.5)} />
				</Stack>
				<Typography
					variant="bodyStrong"
					color={accent}
					tabular
					noWrap
					sx={{
						position: "absolute",
						top: 18,
						left: `${plan.newPct}%`,
						transform: markerTransform,
					}}
				>
					{plan.newYear}
				</Typography>
			</Box>
			<Stack
				direction="row"
				alignSelf="center"
				alignItems="center"
				gap={1}
				px={1.2}
				py={0.6}
				bgcolor={alpha(accent, 0.1)}
				borderRadius="999px"
			>
				<Typography variant="bodyStrong" color={accent} tabular>
					{plan.savedLabel}
				</Typography>
				<Typography variant="caption" color={accent}>
					{t(Resources.Goals.Detail.WhatIf.Earlier.earlier)}
				</Typography>
			</Stack>
		</Stack>
	);
};
